import { styled } from '@vebox/etui-system';
import '../utilities/responsive.js';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { dimensionNames, media } from './config.js';

const _excluded = ["theme"];
const offsetDimensionNames = dimensionNames.map(d => `${d}Offset`);
const ColDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  // @ts-ignore
  const {
    spacingSize
  } = props;
  const spacing = spacingSize ? theme.spacing[spacingSize] : theme.grid.gutterWidth;
  return _objectSpread2({
    boxSizing: 'border-box',
    flex: '0 0 auto',
    pr: `${spacing}px`,
    pl: `${spacing}px`
  }, props);
})`
  ${props => Object.keys(props).filter(prop => ~dimensionNames.indexOf(prop)).sort((prop1, prop2) => dimensionNames.indexOf(prop1) - dimensionNames.indexOf(prop2)).map(prop => media(props.theme)[prop]`${Number.isInteger(props[prop]) ? `
                flex-basis: ${100 / props.theme.grid.gridSize * props[prop]}%;
                max-width: ${100 / props.theme.grid.gridSize * props[prop]}%;
                display: block;
              ` : props[prop] ? `
                  flex-grow: 1;
                  flex-basis: 0;
                  max-width: 100%;
                  display: block;
                ` : 'display: none;'}`)}

  ${props => Object.keys(props).filter(prop => ~offsetDimensionNames.indexOf(prop)).map(prop => media(props.theme)[prop.replace(/Offset$/, '')]`
        margin-left: ${100 / props.theme.grid.gridSize * props[prop]}%;
      `)}
`;

const Col = props => {
  return /*#__PURE__*/createElement(ColDiv, props, props.children);
};

export default Col;
